import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {EDUCATION_CREATED_SUCCESSFULLY} from '../../../../locale/multilingual-strings-constants';
import {EducationModel} from '../../model/employee/education.model';
import {ValidationService} from '../../services/validation.service';
import {NotifierService} from '../../services/notifier.service';
import {PersonalDataService} from '../../../../../personal-data/src/lib/personal-data.service';

@Component({
  selector: 'app-education-popup',
  templateUrl: './education-popup.component.html',
  styleUrls: ['./education-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EducationPopupComponent {
  private readonly personalDataId: string;
  public educationForm: FormGroup;

  constructor(
              private ref: DynamicDialogRef,
              private fb: FormBuilder,
              private notifierService: NotifierService,
              private config: DynamicDialogConfig,
              private validationService: ValidationService,
              private cdr: ChangeDetectorRef,
              private personalDataService: PersonalDataService) {
    const education = config.data.education;
    this.personalDataId = config.data.personalDataId;

    this.educationForm = this.fb.group({
      id: [education?.id],
      personalDataId: [education?.personalDataId || config.data.personalDataId],
      educationType: [education?.educationType, [Validators.required,]],
      institution: [education?.institution, [Validators.required,]],
      specialty: [education?.specialty, [Validators.required,]],
      degree: [education?.degree, [Validators.required,]],
      from: [education?.from ? new Date(education?.from) : null, [Validators.required,]],
      to: [education?.to ? new Date(education?.to) : null, [Validators.required]],
    }, {
      validators: this.validationService.validateDateRange('from', 'to'),
    });
  }

  public submit() {
    if (this.educationForm.valid) {
      this.educationForm.disable();
      const body = this.educationForm.value as EducationModel;
      const submitRequest$ = this.educationForm.value.id ? this.personalDataService.updateEducation(body) :
        this.personalDataService.addEducation(body);

      submitRequest$.subscribe({
        next: response => {
          if (response.succeed) {
            this.notifierService.handleSuccessRequest(EDUCATION_CREATED_SUCCESSFULLY);
            if (!this.educationForm.value.id) {
              this.educationForm.controls['id'].setValue(response.value);
              this.closeDialog(true);
            } else this.closeDialog(false, true);
          } else {
            this.notifierService.handleErrors(response.errors);
            this.educationForm.enable();
          }
          this.cdr.detectChanges();
        },
        error: err => {
          this.notifierService.handleRequestError(err);
          this.educationForm.enable();
          this.cdr.detectChanges();
        }
      })
    }
  }

  public closeDialog(added: boolean, edited?: boolean) {
    this.ref.close({added, edited, education: this.educationForm.value});
  }

}
